import { useRunStore } from '../store/runStore';
import type { Adventure, Instance, InstanceState } from '@gm-binder/shared';

export interface BinderContext {
  adventure: Adventure;
  instance: Instance;
  state: InstanceState;
  slug: string;
}

/**
 * Convenience accessor for section components rendered inside the binder.
 * Returns null while loading; callers inside <BinderLayout> can assume it's present
 * once the layout has finished loading.
 */
export function useBinder(): BinderContext | null {
  const adventure = useRunStore((s) => s.adventure);
  const instance = useRunStore((s) => s.instance);
  if (!adventure || !instance) return null;
  return { adventure, instance, state: instance.state, slug: adventure.slug };
}
